import React from 'react';

const AdvancedToolsToggle = ({ showMoreTools, setShowMoreTools }) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <button
        type="button"
        onClick={() => setShowMoreTools(!showMoreTools)}
        data-tour="more-tools"
        style={{
          background: showMoreTools ? '#f5f5f5' : 'none',
          border: 'none',
          color: '#5e778a',
          cursor: 'pointer',
          fontSize: '13px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          padding: '8px 16px',
          borderRadius: '20px'
        }}
      >
        <span style={{
          transform: showMoreTools ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s',
          display: 'inline-block'
        }}>▼</span>
        {showMoreTools ? 'Hide Analysis Tools' : 'More Analysis Tools'}
      </button>
    </div>
  );
};

export default AdvancedToolsToggle;
